import { render } from "./updatepersonrole.vue?vue&type=template&id=5b40b9a0"
import script from "./updatepersonrole.vue?vue&type=script&lang=js"
export * from "./updatepersonrole.vue?vue&type=script&lang=js"

import "./updatepersonrole.vue?vue&type=style&index=0&id=5b40b9a0&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__